import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {ActivitySourceVisualTypesEnum} from '../../../../models/api/activitySourceModel';
import {
  ConversationOngoingTaskModel,
  OngoingTaskTypesEnum,
} from '../../../../models/api/conversationOngoingTaskModel';
import {TriggerButton} from './triggerButton';

interface OngoingTaskButtonProps {
  ongoingTask: ConversationOngoingTaskModel;
}

export const OngoingTaskButton: FC<OngoingTaskButtonProps> = ({ongoingTask}) => (
  <TriggerButton isLoading title={renderWorkloadTitle(ongoingTask)} />
);

function renderWorkloadTitle(ongoingTask: ConversationOngoingTaskModel) {
  switch (ongoingTask.workloadType) {
    case OngoingTaskTypesEnum.MACRO:
      return ongoingTask.visualType === ActivitySourceVisualTypesEnum.MACRO
        ? ongoingTask.macroName
        : ongoingTask.ruleName;

    case OngoingTaskTypesEnum.FALLBACK_UNKNOWN:
    default:
      return <Trans id="ongoing-task-workload-unknown">Processing</Trans>;
  }
}
